export const USER_ADMIN_PREVIEW = 'permission.useradmin.preview';
export const USER_ADMIN_CREATE = 'permission.useradmin.create';
export const USER_ADMIN_EDIT = 'permission.useradmin.edit';

export const ARTIKLI_PREVIEW = 'permission.artikli.preview';
export const ARTIKLI_CREATE = 'permission.artikli.create';
export const ARTIKLI_EDIT = 'permission.artikli.edit';
export const ARTIKLI_DELETE = 'permission.artikli.delete';

export const KOMITENTI_PREVIEW = 'permission.komitenti.preview';
export const KOMITENTI_CREATE = 'permission.komitenti.create';
export const KOMITENTI_EDIT = 'permission.komitenti.edit';
export const KOMITENTI_DELETE = 'permission.komitenti.delete';

export const IMPORT_CALCULATION_PREVIEW = 'permission.kalkulacije.preview';
export const IMPORT_CALCULATION_CREATE = 'permission.kalkulacije.create';
export const IMPORT_CALCULATION_EDIT = 'permission.kalkulacije.edit';
export const IMPORT_CALCULATION_DELETE = 'permission.kalkulacije.delete';
export const IMPORT_CALCULATION_PRINT = 'permission.kalkulacije.print';
export const IMPORT_CALCULATION_ACTIONS = 'permission.kalkulacije.akcije';

export const STOCK_LIST_PREVIEW = 'permission.lagerlista.preview';
export const STOCK_LIST_PRINT = 'permission.lagerlista.print';

export const FIRME_ADMINISTRATION_PREVIEW = 'permission.firmeadministration.preview';
export const FIRME_ADMINISTRATION_CREATE = 'permission.firmeadministration.create';
export const FIRME_ADMINISTRATION_EDIT = 'permission.firmeadministration.edit';

export const POSTAVKE_PREVIEW = 'permission.postavke.preview';
export const KUPCI_DOBAVLJACI_PREVIEW = 'permission.kupcidobavljaci.preview';
export const KUPCI_DOBAVLJACI_PRINT = 'permission.kupcidobavljaci.print';
export const POTRAZIVANJA_PO_VALUTI = 'permission.potrazivanjapovaluti.preview';
export const DNEVNIK_FINANCISJKOG_KNJIZENJA = 'permission.dnevnikFinancijskogKnjizenja.preview';
export const BRUTO_BILANS_PREVIEW = 'permission.bruto-bilans.preview';
export const FIN_IZVJESTAJI_FIWE_PREVIEW = 'permission.fin-izvjestaji-fiwe.preview';
export const FIN_BLAGAJNA_IZVJESTAJI_FIWE_PREVIEW = 'permission.finb-izvjestaji.preview';

export const SHEME_KNJIZENJA_PEVIEW = 'permission.financijeAutoKnjizenja.preview';
export const TRGOVACKA_KNJIGA_PREVIEW = 'permission.rim.trgovacka-knjiga';
export const POSLOVNE_JEDINICE_PREVIEW = 'permission.poslovnejedinice.preview';

export const PODGRUPE_PREVIEW = 'permission.podgrupe.preview';
export const GRUPE_PREVIEW = 'permission.grupe.preview';
export const GRADOVI_PREVIEW = 'permission.gradovi.preview';
export const POCETNO_STANJE_PREVIEW = 'permission.pocetnostanje.preview';
export const NAPOMENE_PREVIEW = 'permission.napomene.preview';
export const KIF_PREVIEW = 'permission.knjigekif.preview';
export const KUF_PREVIEW = 'permission.knjigekuf.preview';
export const FIN_DOKUMENTI_PREVIEW = 'permission.findokumenti.preview';
export const FIN_NALOZI_PREVIEW = 'permission.financije.preview';
export const RIM_DOKUMENTI_PREVIEW = 'permission.rimDokumenti.preview';
export const KONTNI_PLAN_PREVIEW = 'permission.kontniplan.preview';
export const DMS_TIPOVI_PREVIEW = 'permission.dmstipovi.preview';
export const ZIRO_RACUNI_PREVIEW = 'permission.komitenti-ziro-racuni.preview';
export const FINANCIJSKI_PROJEKTI_PREVIEW = 'permission.fin-projekti.preview';
export const STALNA_SREDSTVA_PREVIEW = 'permission.stalnasredstva.preview';
export const FAKTURISANJE_PREVIEW = 'permission.fakturisanje.preview';
export const KALKULACIJE_PREVIEW = 'permission.kalkulacije.preview';
export const PRIJEMNI_LIST_PREVIEW = 'permission.prijemnilist.preview';
export const UNOS_POPISA_PREVIEW = 'permission.unospopisa.preview';
export const POPIS_PREVIEW = 'permission.popis.preview';
export const NIVELACIJE_CIJENA_PREVIEW = 'permission.nivelacije-cijena.preview';
export const PREDISPOZICIJE_PREVIEW = 'permission.predispozicije.preview';
export const ULAZNE_PREDISPOZICIJE_PREVIEW = 'permission.ulazne-predispozicije.preview';
export const FIN_NALOZI_PODACI_PREVIEW = 'permission.financijenalozipodaci.preview';
export const KIF_PODACI_PREVIEW = 'permission.knjigekifpodaci.preview';
export const KUF_PODACI_PREVIEW = 'permission.knjigekufpodaci.preview';
export const RADNICI_PREVIEW = 'permission.radnici.preview';
export const OBRACUNI_PLACA_PREVIEW = 'permission.obracuni-placa.preview';
export const VIRMANI_PREVIEW = 'permission.virmani.preview';
export const DMS_PREVIEW = 'permission.dms.preview';
export const AMORTIZACIJE_PREVIEW = 'permission.amortizacije.preview';
export const IZLAZ_OTPIS_SS_PREVIEW = 'permission.izlaz-otpis-ss.preview';
export const OBRTNICI_KIF_KUF_PREVIEW = 'permission.obrtnici-kif-kuf.preview';
export const VISAK_MANJAK_PREVIEW = 'permission.visak-manjak.preview';

export const FIN_KNJIGOVODSTVENI_IZVJESTAJI_FIWE_PREVIEW = 'permission.fin-knjigovodstveni-izvjestaji.preview';
export const RADNI_NALOZI_PREVIEW = 'permission.radni-nalozi.preview';
export const ULAZ_PROIZVODA_PREVIEW = 'permission.ulaz-proizvoda.preview';
export const IZDATNICE_MATERIJALA_PREVIEW = 'permission.izdatnica-materijala.preview';
export const NORMATIVI_PREVIEW = 'permission.normativi.preview';
export const TREBOVANJA_PREVIEW = 'permission.radni-nalozi-trebovanje.preview';
export const KOMPENZACIJE_PREVIEW = 'permission.kompenzacije.preview';